export const conditionMap = {
    "True": ["y", "yes", "t", "true"],
    "False": ["n", "no", "f", "false"],
};